var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-etapa4')
}
var staticRenderFns = []

export { render, staticRenderFns }